import * as React from "react";
import type { SVGProps } from "react";
const SvgReclamation = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v6a1 1 0 1 1-2 0V6a1 1 0 0 0-1-1h-2v4h.003l.002 2h-1.237l-.21-.105L13 10.118l-.553.276-.447.224-.447-.224-.553-.276-1.547.776L9.24 11H8V5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h5a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3zm11 2.382V5h-4v3.383l.552-.277.447-.224.448.224.553.276.553-.276.447-.224.447.223zM16.414 14l-.707.707-.293.293H18.5a3.5 3.5 0 1 1 0 7H17a1 1 0 0 1 0-2h1.5a1.5 1.5 0 0 0 0-3h-3.086l.293.293.707.707L15 19.414l-.707-.707-2-2a1 1 0 0 1 0-1.414l2-2 .707-.707z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgReclamation;
